import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-send-absent-notification',
  templateUrl: './send-absent-notification.component.html',
  styleUrls: ['./send-absent-notification.component.scss']
})
export class SendAbsentNotificationComponent implements OnInit {
  @Input()
  sendNotification: boolean = false;
  @Output()
  sendNotificationEmitter = new EventEmitter<boolean>();
  constructor(public translate: TranslateService) {}

  ngOnInit() {}

  sendNotificationChanged(): void {
    this.sendNotificationEmitter.emit(this.sendNotification);
  }
}
